export default __webpack_public_path__ + "assets/images/0ec31c48ba58a4ba58919d7a6b4e7c58.png";